export const FLOATING_ALERT_TIMING = '300ms';